import { useProjectStore } from '@/core/project/store/project.store'
import { useStoryStore } from '@/features/shared/stores/story.store'
import { useStEditorStore } from '@/features/story/stores/st-editor.store'
import React from 'react'

export function StEditorProvider({ children }: { children: React.ReactNode }) {
    // The store is global, so the provider is not strictly needed for context anymore.
    // However, if we need to reset the store on unmount or provider mount, we can do it here.
    const { storyEntity } = useStoryStore()
    const { project } = useProjectStore()

    React.useEffect(() => {

        console.log('storyEntity in stroy provider', storyEntity)
        return () => {
            // Cleanup on unmount if desired, though global state persistence might be desired.
            // For now, let's clear the editor reference to avoid leaks.
            // setEditor(null) 
        }
    }, [])

    return <>{children}</>
}

export { useStEditorProvider } from '@/features/story/stores/st-editor.store'
